var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49902 0C3.25638 0 2.24902 1.00735 2.24902 2.25C2.24902 3.49265 3.25638 4.5 4.49902 4.5C5.74167 4.5 6.74902 3.49265 6.74902 2.25C6.74902 1.00735 5.74167 0 4.49902 0ZM3.37402 2.25C3.37402 1.62869 3.87771 1.125 4.49902 1.125C5.12033 1.125 5.62402 1.62869 5.62402 2.25C5.62402 2.87131 5.12033 3.375 4.49902 3.375C3.87771 3.375 3.37402 2.87131 3.37402 2.25Z",
    fill: "#64748B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 6.82537 1.76288 5.0625 3.9375 5.0625H5.0625C7.23712 5.0625 9 6.82537 9 9V9.5625C9 9.87317 8.74817 10.125 8.4375 10.125C8.12683 10.125 7.875 9.87317 7.875 9.5625V9C7.875 7.44668 6.61582 6.1875 5.0625 6.1875V7.875C5.0625 8.18567 4.81067 8.4375 4.5 8.4375C4.18933 8.4375 3.9375 8.18567 3.9375 7.875V6.1875C2.38421 6.1875 1.125 7.44668 1.125 9V9.5625C1.125 9.87317 0.873169 10.125 0.5625 10.125C0.251831 10.125 0 9.87317 0 9.5625V9Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/admin-icon.ae59fb50f84ba1bac0ffd68ab3f37f6f.svg";
export { ForwardRef as ReactComponent };